import { render } from "./WorkBench.vue?vue&type=template&id=074c5136&scoped=true&ts=true"
import script from "./WorkBench.vue?vue&type=script&lang=ts"
export * from "./WorkBench.vue?vue&type=script&lang=ts"

import "./WorkBench.vue?vue&type=style&index=0&id=074c5136&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074c5136"]])

export default __exports__